export default __webpack_public_path__ + "static/media/add-life-event-button.090627f3.svg";